import React, {Component} from "react";
import BPContestDetailByFWDStaff from "./fwd/BPContestDetailByFWDStaff";
import {connect} from "react-redux";
import AccessDeny from "../AccessDeny";
import BPContestDetailByVCBHO from "./vcb/BPContestDetailByVCBHO";
import BPContestDetailByVCBBO from "./vcb/BPContestDetailByVCBBO";
import BPContestDetailByVCBTO from "./vcb/BPContestDetailByVCBTO";
import BPContestDetailByAGBHO from "./agb/BPContestDetailByAGBHO";
import BPContestDetailByAGBBO from "./agb/BPContestDetailByAGBBO";
import BPContestDetailByAGBTO from "./agb/BPContestDetailByAGBTO";
import BPContestDetailByVCBBankstaff from "./vcb/BPContestDetailByVCBBankstaff";
class BPContestDetail extends Component{

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }

    render() {
        if(this.props?.isRoleFWDContest) return <BPContestDetailByFWDStaff id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'VCB' && this.props?.isRoleHO) return <BPContestDetailByVCBHO id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'VCB' && this.props?.isRoleBO) return <BPContestDetailByVCBBO id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'VCB' && this.props?.isRoleTO) return <BPContestDetailByVCBTO id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'VCB' && this.props?.isRoleBankStaff) return <BPContestDetailByVCBBankstaff id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'AGR' && this.props?.isRoleHO) return <BPContestDetailByAGBHO id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'AGR' && this.props?.isRoleBO) return <BPContestDetailByAGBBO id={this.props?.match?.params?.contestId} />
        if(this.props?.bankCode === 'AGR' && this.props?.isRoleTO) return <BPContestDetailByAGBTO id={this.props?.match?.params?.contestId} />
        return <AccessDeny />
    }
}
const mapStateToProps = (state) => {
    const authorities = state?.auth?.authorities;
    const isRoleHO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_HO');
    const isRoleFWDContest = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BP_CONTEST');
    const isRoleBO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BO');
    const isRoleTO = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_TO');
    const isRoleBankStaff = (authorities || [])?.map((e) => e.authority)?.includes('ROLE_BANKSTAFF');
    const username = state?.auth?.name;
    const bankCode = state?.lookup?.bank;
    return { username,isRoleHO, isRoleFWDContest, isRoleBO, isRoleTO, isRoleBankStaff, bankCode};
};

export default connect(mapStateToProps)(BPContestDetail);